"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IssuePermissionsApi = void 0;
var _endpointHelpers = require("../util/endpointHelpers");
var _queryClientUtils = require("../util/queryClientUtils");
const IssuePermissionsApi = exports.IssuePermissionsApi = (0, _endpointHelpers.createEndpointSdk)(_ref => {
  let {
    api
  } = _ref;
  return {
    getAll: () => api.getAll("permissions"),
    batchCreate: resources => api.batchCreate("permissions/batch_operation", {
      operations: resources.map(resource => ({
        correlationId: resource.subject,
        op: "create",
        resource
      }))
    }).then(_ref2 => {
      let {
        operations
      } = _ref2;
      return operations.filter(_ref3 => {
        let {
          status
        } = _ref3;
        return status === "success";
      }).map(_ref4 => {
        let {
          resource
        } = _ref4;
        return resource;
      });
    }),
    update: (id, attributes) => api.update("permissions/".concat(id), attributes),
    delete: id => api.delete("permissions/".concat(id))
  };
}, {
  invalidateByQueryKeys: () => _queryClientUtils.INVALIDATE_ALL_QUERIES
});
//# sourceMappingURL=IssuePermissionsApi.js.map